<template>
  <div class="filter-group">
    <div class="filter-group-name">{{ label }}</div>
    <van-checkbox-group
      :value="value"
      direction="horizontal"
      icon-size="0.8rem"
      checked-color="#000"
      @input="onChange"
    >
      <div class="checkbox-list" :style="{ '--column-number': cols }">
        <van-checkbox
          v-for="(item, index) in options"
          :key="index"
          :title="item"
          :name="item.value"
          shape="square"
          class="checkbox-item"
          @click="onItemClick(item)"
          >{{ item.label }}</van-checkbox
        >
      </div>
      <slot />
    </van-checkbox-group>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    options: Array,
    value: Array,
    cols: {
      type: Number,
      default: 3,
    },
  },
  methods: {
    onChange(e) {
      //   console.log("onChange", e);
      this.$emit("input", e);
    },
    onItemClick(item) {
      this.$emit("itemclick", item);
    },
  },
};
</script>

<style lang="less" scoped>
.filter-group {
  padding: 8/20rem 0;
  &-name {
    font-weight: 400;
    font-size: 14/20rem;
    line-height: 21/20rem;
    letter-spacing: 0;
    color: #000;
  }
}

.checkbox-list {
  display: grid;
  grid-template-columns: repeat(var(--column-number), 1fr);

  width: 100%;
}
</style>

<style lang="less">
.filter-group {
  .checkbox-list {
    .checkbox-item {
      height: 23/20rem;
      margin-top: 10/20rem;
      font-size: 12/20rem;
      font-weight: 400;
      .van-checkbox__icon .van-icon,
      .van-radio__icon .van-icon {
        border-width: 2px;
      }
    }
  }
}
</style>
